import { Box, Button, TextField, Typography } from "@mui/material";
import { useState } from "react";
import {
  IModalComponentProps,
  ModalComponent,
} from "../../ModalComponent/ModalComponent";

interface INoteComponentProps extends IModalComponentProps {
  handleSave: (v: string) => void;
  value: string;
}

export function NoteComponent({
  value,
  handleSave,
  onClose,
  ...modalProps
}: INoteComponentProps) {
  const [isEdit, setIsEdit] = useState(!value);
  const [inputValue, setInputValue] = useState(value);

  const modalFooter = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {!isEdit ? (
        <Button
          onClick={() => setIsEdit(true)}
          color="primary"
          variant="outlined"
        >
          Редактировать
        </Button>
      ) : (
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleSave(inputValue)}
        >
          Сохранить
        </Button>
      )}
    </Box>
  );

  return (
    <>
      <ModalComponent
        small
        onClose={isEdit && value ? () => setIsEdit(false) : onClose}
        {...modalProps}
        title="Примечание"
        modalFooter={modalFooter}
      >
        <Box>
          {isEdit ? (
            <TextField
              multiline
              fullWidth
              rows={5}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              slotProps={{
                htmlInput: { maxLength: 255 },
              }}
            />
          ) : (
            <Typography sx={{ wordWrap: "break-word" }}>{value}</Typography>
          )}
        </Box>
      </ModalComponent>
    </>
  );
}
